export const CHILD = {
  nickname: 'PRODUCTS.CHILD.nickname',
  lifeInsurance: true,
  icon:'child'
};
